import { render, staticRenderFns } from "./BuoniPasto.vue?vue&type=template&id=69cc13e1&scoped=true"
import script from "./BuoniPasto.vue?vue&type=script&lang=js"
export * from "./BuoniPasto.vue?vue&type=script&lang=js"
import style0 from "./BuoniPasto.vue?vue&type=style&index=0&id=69cc13e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cc13e1",
  null
  
)

export default component.exports